// extracted by mini-css-extract-plugin
export default {"babySizeImageWrapper":"BabySizeImage_babySizeImageWrapper__7mrtR","babySizeImage":"BabySizeImage_babySizeImage__k0Slo"};